import React from 'react';
import { toast } from 'react-toastify';
import classnames from 'classnames'
import axios from 'axios';

import FilterComponent from '../../../../asset/simple_asset/helper/component/FilterComponent.js';
import iconMaping from '../../../../utils/IconMaping.js';
import UserRow from './UserRow.js';
import Modal from './Modal.js';

// Component
import Pagination from '../../../../component/Pagination.js'
import {TableRowLoading, TableRowEmpty} from '../../../../component/ComponentHelper.js'
// import CheckPermission from '../../../../component/CheckPermission.js'

// Config
// import PermissionProperties from '../../../../config/permission.js'
import Request from '../../../../config/Request.js'
import {RequestAsync} from '../../../../config/RequestAsync'

//Utils
import handlingError from "../../../../utils/handlingError.js"
import windowStop from '../../../../utils/windowStop.js';
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';

export default class UserList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rawData       : [],
      isModal       : false,
      modalMode     : null,
      data          : {
        alias    : "",
        username : "",
        firstname: "",
        lastname : "",
        email    : "",
        phone    : "",
        address  : "",
        address2 : "",
        city     : "",
        postal   : "",
        next_of_kin: "",
        phone_next_of_kin: "",
        tag      : "",
        role     : "",
        is_active: "",
      },
      activeToggle  : {activeIcon : null, activeField : 'Name'},
      is_process    : false,
      toggle_tab: "user",
      // ***Pagination
      table_loading : false,
      current       : 0,
      count         : 0,
      limit         : 0,
    }
    this._isMounted = false
    this.signal = axios.CancelToken.source()
    this.loading = true;
    this.tab     = ['user name', 'full name', 'phone', 'city', 'role']

    this.params_filter = '';
    this.params_order  = '-CreatedTime';
    this.params_page   = 1;

    this.onRegister      = this.onRegister.bind(this)
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this)
    this.onRegisterFailed  = this.onRegisterFailed.bind(this)

    this.onUpdate        = this.onUpdate.bind(this)
    this.onUpdateSuccess   = this.onUpdateSuccess.bind(this)
    this.onUpdateFailed    = this.onUpdateFailed.bind(this)

    this.onUpdatePassword        = this.onUpdatePassword.bind(this)
    this.onUpdatePasswordSuccess = this.onUpdatePasswordSuccess.bind(this)
    this.onUpdatePasswordFailed  = this.onUpdatePasswordFailed.bind(this)

    this.setDataEdit     = this.setDataEdit.bind(this)

    this.openModal  = this.openModal.bind(this)
    this.closeModal  = this.closeModal.bind(this)

    this.toggleTab = this.toggleTab.bind(this)

    this.handlePageClick  = this.handlePageClick.bind(this)
  }

  toggleTab(tab) {
    this.setState({toggle_tab: tab})
  }

  openModal(mode) {
    this.setState({
      modalMode : mode,
      isModal   : true,
      toggle_tab: "user"
    })
  }

  closeModal() {
    this.setState({isModal: false})
  }

  setDataEdit(data) {
    this.setState({
      data: {
        alias    : data.Alias,
        username : data.Username,
        firstname: data.FirstName,
        lastname : data.LastName,
        email    : data.Email,
        phone    : data.Phone,
        address  : data.Address,
        address2 : data.Address2,
        city     : data.City,
        postal   : data.Postal,
        next_of_kin: data.NextOfKin,
        phone_next_of_kin: data.PhoneNo,
        tag      : data.Tag,
        role     : data.Role,
        is_active: data.Active,
      }
    })
    this.openModal("modal_update")
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <UserRow
          key        ={index}
          isModal    ={this.state.isModal}
          RowData    ={val}
          history    ={this.props.history}
          open       ={this.openModal}
          close      ={this.closeModal}
          setDataEdit={this.setDataEdit}
        />
      )
    })
    return element;
  }

  onLoad = async () => {
    try {
      let data = Object.assign({
        page     : this.params_page,
        ordering : this.params_order,
      }, this.params_filter)

      this.loading = false
      const response = await RequestAsync(
        'read-user',
        {Authorization: "Bearer " + this.props.UserReducer.token},
        data,
        this.signal.token
      )
      
      if(this._isMounted) {
        this.setState({
          rawData       : response.data.results,
          table_loading : false,
          current       : response.data.current,
          count         : response.data.count,
          limit         : response.data.limit,
        })
      }

    } catch (err) {
      this.loading = false
      if(this._isMounted) {
        this.setState({
          table_loading : false,
        })
      }
    }
  }

  /**
  |--------------------------------------------------
  | Register
  |--------------------------------------------------
  */
  onRegister(data) {
    let payload = {
      Alias    : data.alias,
      Username : data.username,
      Password : data.password,
      FirstName: data.firstname,
      LastName : data.lastname,
      Email    : data.email,
      Phone    : data.phone,
      Address  : data.address,
      Address2 : data.address2,
      City     : data.city,
      Postal   : data.postal,
      NextOfKin: data.next_of_kin,
      PhoneNo  : data.phone_next_of_kin,
      Tag      : data.tag,
      Role     : data.role,
      Active  : data.is_active,
    }

    Request(
      "post",
      "register-user",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      payload,
      [],
      this.onRegisterSuccess,
      this.onRegisterFailed,
    )

    this.setState({
      is_process: true
    })
  }

  onRegisterSuccess(response) {
    this.closeModal()
    this.setState({is_process: false})
    toast.success("Register user success")
    this.onLoad()
  }

  onRegisterFailed(error) {
    this.setState({is_process: false})
    handlingError(error.response.data)
  }

  /**
  |--------------------------------------------------
  | Update
  |--------------------------------------------------
  */
  onUpdate(data) {
    this.setState({is_process: true})

    let payload = {
      Alias    : data.alias,
      Username : data.username,
      FirstName: data.firstname,
      LastName : data.lastname,
      Email    : data.email,
      Phone    : data.phone,
      Address  : data.address,
      Address2 : data.address2,
      City     : data.city,
      Postal   : data.postal,
      NextOfKin: data.next_of_kin,
      PhoneNo  : data.phone_next_of_kin,
      Tag      : data.tag,
      Role     : data.role,
      Active   : data.is_active,
    }

    Request(
      "put",
      "update-user",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      payload,
      [data.alias],
      this.onUpdateSuccess,
      this.onUpdateFailed,
    )
  }

  onUpdateSuccess(response) {
    this.closeModal()
    toast.success("Update user success")
    this.onLoad()
    this.setState({is_process: false})
  }

  onUpdateFailed(error) {
    this.setState({ is_process: false })
    handlingError(error.response.data)
  }

  onUpdatePassword(data) {
    let payload = {
      Password: data.password
    }

    Request(
      "put",
      "update-user-password",
      {Authorization: "Bearer " + this.props.UserReducer.token},
      payload,
      [data.alias],
      this.onUpdatePasswordSuccess,
      this.onUpdatePasswordFailed,
    )
  }

  onUpdatePasswordSuccess() {
    this.closeModal()
    toast.success("Update password user success")
  }

  onUpdatePasswordFailed(error) {
    handlingError(error.response.data)
  }

  dataWillFilter(filter){
    this.params_filter = filter;
    this.params_page = 1

    this.onLoad()
  }

  dataWillOrder(order){
    let parameter_order = order;
    this.setState({activeToggle: {
      activeField : order,
      activeIcon  : iconMaping.AVICON_ASC
    }})

    if(this.params_order === parameter_order){
      this.params_order = '-' + order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_DESC
      }})

    } else {
      this.params_order = parameter_order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_ASC
      }})
    }

    this.onLoad()
  }
  
  mounted() {
    if(this._isMounted) {
      this.onLoad()
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.mounted()
  }

  componentWillUnmount(){
    this._isMounted = false
    this.signal.cancel();
    windowStop()
  }

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.params_page = selected

    this.setState({
      table_loading: true,
    })

    this.onLoad()
  };

  RenderRow() {
    if(this.loading) {
      return (<TableRowLoading />)

    } else if(this.state.rawData.length > 0) {
      return (this.generateRow(this.state.rawData))

    } else {
      return (<TableRowEmpty/>)
    }
  }

  render() {
    const {
      activeToggle,
      current,
      count,
      limit,
      table_loading,
    } = this.state

    return (
      <div>
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">User</h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                Total:&nbsp;{count}&nbsp;User
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent
              onSearch = {(e) => {this.dataWillFilter(e)}}
              self     = {this}
              target   = {'idle'}
              FBColumn = {this.tab}
              version  = {2}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 mt-4">
            <button className="btn btn-sm btn-primary" onClick={()=>this.openModal('modal_add')}>Add new</button>
          </div>
        </div>
        <div className="table-wrapper">
          <table className={classnames("table table-hover table-outline mb-0 m-top-15", {'loading' : table_loading})}>
            <thead className="thead-default">
              <tr>
                <th onClick={()=>this.dataWillOrder('User__username')} className="pointer">
                  User Name{activeToggle.activeField === 'User__username' && <i className={activeToggle.activeIcon}></i>}
                </th>
                <th onClick={()=>this.dataWillOrder('FullName')} className="pointer">
                  Full Name{activeToggle.activeField === 'FullName' && <i className={activeToggle.activeIcon}></i>}
                </th>
                <th onClick={()=>this.dataWillOrder('Phone')} className="pointer">
                  Phone{activeToggle.activeField === 'Phone' && <i className={activeToggle.activeIcon}></i>}
                </th>
                <th onClick={()=>this.dataWillOrder('City__Name')} className="pointer">
                  City{activeToggle.activeField === 'City__Name' && <i className={activeToggle.activeIcon}></i>}
                </th>
                <th onClick={()=>this.dataWillOrder('Role__Name')} className="pointer">
                  Role{activeToggle.activeField === 'Role__Name' && <i className={activeToggle.activeIcon}></i>}
                </th>
                <th className="text-center pointer">
                  <span onClick={()=>this.dataWillOrder('Status')}>Status</span><PopoverHelper
                    id='setting_user_status' 
                    content={lang.setting_user.status}
                  />{activeToggle.activeField === 'Status' && <i className={activeToggle.activeIcon}></i>}
                </th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {this.RenderRow()}
            </tbody>
          </table>
        </div>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {current}
              count    = {count}
              limit    = {limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>

        <Modal
          isModal     = {this.state.isModal}
          open        = {this.openModal}
          close       = {this.closeModal}
          mode        = {this.state.modalMode}
          register    = {this.onRegister}
          update      = {this.onUpdate}
          updatePass  = {this.onUpdatePassword}
          data        = {this.state.data}
          is_process  = {this.state.is_process}
          toggle_tab  = {this.state.toggle_tab}
          toggleTab   = {this.toggleTab}
          UserReducer = {this.props.UserReducer}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/user/user/helper/component/UserList.js